import { Log } from './log';

export class Heartbeat {
	public static isStarted = false;

	public static start(
		videoSessionId: number,
		onHeartBeatResponseCallBack: (message: string) => void,
	): void {
		if (this.isStarted) {
			Log.info('Heartbeat already started', { videoSessionId });
			return;
		}
		this.isStarted = true;
		setInterval(
			() => Heartbeat.loop(videoSessionId, onHeartBeatResponseCallBack),
			3000,
		);
	}

	private static loop(
		videoSessionId: number,
		onHeartBeatResponseCallBack: (message: string) => void,
	): void {
		fetch('/api/meetings/heartbeat/' + videoSessionId, {
			method: 'POST',
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
			})
			.then((data) => {
				onHeartBeatResponseCallBack(
					data.message?.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />') ??
						'',
				);
			})
			.catch(function (exception) {
				Log.error('Could not send heartbeat', {
					videoSessionId,
					exception,
				});
			});
	}
}
